// extracted by mini-css-extract-plugin
export var languageList = "LanguageSwitcher-module--languageList--6ad09";
export var wrapper = "LanguageSwitcher-module--wrapper--3d135";